import * as React from "react";

const PinIcon = (props) => (
    <svg width={props.width} height={props.height} viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M52 22.4545C52 38.3636 27 52 27 52C27 52 2 38.3636 2 22.4545C2 17.0297 4.63392 11.827 9.32233 7.991C14.0107 4.15503 20.3696 2 27 2C33.6304 2 39.9893 4.15503 44.6777 7.991C49.3661 11.827 52 17.0297 52 22.4545Z" stroke={props.stroke} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M27 29.2727C31.6024 29.2727 35.3333 26.2201 35.3333 22.4545C35.3333 18.689 31.6024 15.6364 27 15.6364C22.3976 15.6364 18.6667 18.689 18.6667 22.4545C18.6667 26.2201 22.3976 29.2727 27 29.2727Z" stroke={props.stroke} stroke-width="4" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
)

export default PinIcon